export default __webpack_public_path__ + "static/media/ecofriendly.5a4578f2.webp";